
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import AuthCard from "@/components/Auth/AuthCard";
import Header from "@/components/HeaderUpdated";
import Footer from "@/components/Footer";

const Auth: React.FC = () => {
  const { user, isAdmin } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      // Redirect based on user role
      if (isAdmin) {
        navigate("/dashboard");
      } else {
        navigate("/my-account");
      }
    }
  }, [user, isAdmin, navigate]);

  const handleSuccessfulAuth = (isAdminUser = false) => {
    // Redirect based on user role
    if (isAdminUser) {
      navigate("/dashboard");
    } else {
      navigate("/my-account");
    }
  };

  return (
    <div className="min-h-screen bg-brand-darker flex flex-col">
      {/* Header with special prop to hide login/register links when on auth page */}
      <Header hideAuthLinks={true} />

      {/* Main Content */}
      <div className="flex-1 flex items-center justify-center p-4 py-16">
        <div className="w-full max-w-md">
          <AuthCard onSuccessfulAuth={handleSuccessfulAuth} />
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Auth;
